type Measurement = "mood" | "density" | "flow";

const TOTAL = {
  ONE: {
    val: 1,
    risk: "Very Low",
    color: "#00a14b",
    backgroundColor: "#00a14b10",
  },
  TWO: {
    val: 2,
    risk: "Low",
    color: "#ffde17",
    backgroundColor: "#ffde1740",
  },
  THREE: {
    val: 3,
    risk: "Medium",
    color: "#f26522",
    backgroundColor: "#f2652250",
  },
  FOUR: {
    val: 4,
    risk: "High",
    color: "#ed1c24",
    backgroundColor: "#ed1c2480",
  },
};
const DENSITY = {
  ONE: {
    val: 1,
    risk: "Low",
    color: "#00a14b",
    backgroundColor: "#00a14b10",
  },
  TWO: {
    val: 2,
    risk: "Medium",
    color: "#f26522",
    backgroundColor: "#f2652250",
  },
  THREE: {
    val: 3,
    risk: "High",
    color: "#ed1c24",
    backgroundColor: "#ed1c2480",
  },
};
const FLOW = {
  ONE: {
    val: 1,
    risk: "Very Low",
    color: "#00a14b",
    backgroundColor: "#00a14b10",
  },
  TWO: {
    val: 2,
    risk: "Low",
    color: "#00a14b",
    backgroundColor: "#00a14b10",
  },
  THREE: {
    val: 3,
    risk: "Medium",
    color: "#ffde17",
    backgroundColor: "#ffde1740",
  },
  FOUR: {
    val: 4,
    risk: "High",
    color: "#f26522",
    backgroundColor: "#f2652250",
  },
  FIVE: {
    val: 5,
    risk: "Very High",
    color: "#ed1c24",
    backgroundColor: "#ed1c2480",
  },
};
const MOOD = {
  ONE: {
    val: 1,
    risk: "Low",
    color: "#00a14b",
    backgroundColor: "#00a14b10",
  },
  TWO: {
    val: 2,
    risk: "Medium",
    color: "#f26522",
    backgroundColor: "#f2652250",
  },
  THREE: {
    val: 3,
    risk: "High",
    color: "#ed1c24",
    backgroundColor: "#ed1c2480",
  },
};

export const measurementRisk = (type: Measurement, value: number) => {
  switch (type) {
    case "density":
      return value < 1.5
        ? DENSITY.ONE
        : value < 2.5
        ? DENSITY.TWO
        : DENSITY.THREE;
    case "flow":
      return value < 23
        ? FLOW.ONE
        : value < 33
        ? FLOW.TWO
        : value < 66
        ? FLOW.THREE
        : value < 82
        ? FLOW.FOUR
        : FLOW.FIVE;
    case "mood":
      return value < 0.3 ? MOOD.ONE : value < 0.7 ? MOOD.TWO : MOOD.THREE;

    default:
      return TOTAL.ONE;
  }
};

const DEFAULT_D = 1.4;
const DEFAULT_F = 5;
const DEFAULT_M = 0.4;

//BASED ON density level mood 3 tier matrix
export const overallRisk = (
  inputs: {
    density: number;
    flow: number;
    mood: number;
  },
  riskWeights: { m: number; d: number; f: number }
) => {
  const densityLevel =
    measurementRisk("density", inputs.density || DEFAULT_D).val * riskWeights.d;
  const flowLevel =
    measurementRisk("flow", inputs.flow || DEFAULT_F).val * riskWeights.f;
  const moodLevel =
    measurementRisk("mood", inputs.mood || DEFAULT_M).val * riskWeights.m;

  switch (densityLevel) {
    case 1:
      if (moodLevel === 3) return TOTAL.THREE;
      if (moodLevel === 2) return TOTAL.ONE;
      if (moodLevel === 1) {
        if (flowLevel === 5) return TOTAL.THREE;
        return TOTAL.ONE;
      }
      console.log("Mood Level out of bounds-1");
      return TOTAL.ONE; //In case of error
    case 2:
      if (moodLevel === 3) return TOTAL.THREE;
      if (moodLevel === 1) return TOTAL.THREE;
      if (moodLevel === 2) {
        if (flowLevel < 3) return TOTAL.THREE;
        return TOTAL.ONE;
      }
      console.log("Mood Level out of bounds-2");
      return TOTAL.ONE; //In case of error
    case 3:
      if (flowLevel === 3 || flowLevel === 4) return TOTAL.THREE;
      return TOTAL.FOUR;
    default:
      console.log("Default reached-check for errors");
      return TOTAL.ONE;
  }
};
